import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "upload-settings"
};
const _hoisted_2 = {
  class: "page-header"
};
const _hoisted_3 = {
  class: "first-title"
};
const _hoisted_4 = {
  class: "header-actions"
};
const _hoisted_5 = {
  class: "group-header"
};
const _hoisted_6 = {
  class: "group-title"
};
const _hoisted_7 = {
  key: 0,
  class: "load-balance-switch"
};
const _hoisted_8 = {
  class: "switch-label"
};
const _hoisted_9 = {
  key: 0,
  class: "channel-cards"
};
const _hoisted_10 = ["onMousemove", "onMouseleave"];
const _hoisted_11 = {
  class: "card-header"
};
const _hoisted_12 = {
  class: "card-title"
};
const _hoisted_13 = {
  class: "channel-name"
};
const _hoisted_14 = {
  class: "card-body"
};
const _hoisted_15 = {
  class: "card-info"
};
const _hoisted_16 = {
  class: "info-item"
};
const _hoisted_17 = {
  class: "info-text"
};
const _hoisted_18 = {
  key: 0,
  class: "info-item"
};
const _hoisted_19 = {
  class: "info-text"
};
const _hoisted_20 = {
  key: 1,
  class: "info-item"
};
const _hoisted_21 = ["title"];
const _hoisted_22 = {
  class: "info-item"
};
const _hoisted_23 = {
  class: "info-text"
};
const _hoisted_24 = {
  key: 0,
  class: "info-item"
};
const _hoisted_25 = ["title"];
const _hoisted_26 = {
  class: "info-item"
};
const _hoisted_27 = {
  class: "info-text"
};
const _hoisted_28 = {
  class: "info-item"
};
const _hoisted_29 = {
  class: "info-text"
};
const _hoisted_30 = {
  class: "info-item"
};
const _hoisted_31 = {
  class: "info-text"
};
const _hoisted_32 = {
  class: "info-item"
};
const _hoisted_33 = ["title"];
const _hoisted_34 = {
  key: 0,
  class: "info-item"
};
const _hoisted_35 = ["title"];
const _hoisted_36 = {
  key: 0,
  class: "quota-mini"
};
const _hoisted_37 = {
  class: "quota-text"
};
const _hoisted_38 = {
  class: "card-actions"
};
const _hoisted_39 = {
  key: 1,
  class: "empty-tip"
};
const _hoisted_40 = {
  class: "channel-type-option"
};
const _hoisted_41 = {
  key: 0,
  class: "form-warning",
  style: {
    "margin-top": "0"
  }
};
const _hoisted_42 = ["innerHTML"];
const _hoisted_43 = {
  class: "form-warning"
};
const _hoisted_44 = {
  class: "quota-label"
};
const _hoisted_45 = {
  class: "quota-status"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_CustomSelect = _resolveComponent("CustomSelect");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ChannelIcon = _resolveComponent("ChannelIcon");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.title')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysUpload.titleTooltip'),
    placement: "right"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      class: "help-icon"
    })]),
    _: 1
  }, 8, ["content"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_CustomSelect, {
    modelValue: $data.channelFilter,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.channelFilter = $event),
    options: $options.filterOptions,
    placeholder: _ctx.$t('sysUpload.filterPlaceholder'),
    width: "160px"
  }, null, 8, ["modelValue", "options", "placeholder"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _cache[1] || (_cache[1] = $event => $data.showAddDialog = true),
    class: "add-btn"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "plus",
      style: {
        "margin-right": "6px"
      }
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('sysUpload.addChannel')), 1)]),
    _: 1
  })])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredChannels, channelType => {
    return _openBlock(), _createElementBlock("div", {
      key: channelType.value,
      class: "channel-group"
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_ChannelIcon, {
      type: channelType.value,
      class: "group-icon"
    }, null, 8, ["type"]), _createElementVNode("span", null, _toDisplayString(channelType.label), 1), _createVNode(_component_el_tag, {
      size: "small",
      type: "info",
      class: "channel-count"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getChannelList(channelType.value).length), 1)]),
      _: 2
    }, 1024)]), $options.hasLoadBalance(channelType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('sysUpload.loadBalance')), 1), _createVNode(_component_el_switch, {
      modelValue: $options.getSettings(channelType.value).loadBalance.enabled,
      "onUpdate:modelValue": $event => $options.getSettings(channelType.value).loadBalance.enabled = $event,
      size: "small",
      onChange: $options.saveSettings
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])) : _createCommentVNode("", true)]), $options.getChannelList(channelType.value).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChannelList(channelType.value), (channel, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: channel.name || index,
        class: _normalizeClass(["channel-card", [channelType.value, {
          'disabled': !channel.enabled,
          'fixed': channel.fixed
        }]]),
        onMousemove: $event => $options.handleCardMouseMove($event, channelType.value, index),
        onMouseleave: $event => $options.handleCardMouseLeave(channelType.value, index)
      }, [_createElementVNode("div", {
        class: "card-glow",
        ref_for: true,
        ref: `glow-${channelType.value}-${index}`
      }, null, 512), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(channel.name || _ctx.$t('sysUpload.unnamedChannel')), 1), channel.fixed ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        size: "small",
        type: "warning"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.envVariable')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_el_switch, {
        modelValue: channel.enabled,
        "onUpdate:modelValue": $event => channel.enabled = $event,
        size: "small",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
        onChange: $options.saveSettings
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [channelType.value === 'telegram' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_font_awesome_icon, {
        icon: "robot",
        class: "info-icon"
      }), _createElementVNode("span", _hoisted_17, "Bot: " + _toDisplayString($options.maskText(channel.botToken)), 1)]), channel.chatId ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_font_awesome_icon, {
        icon: "comments",
        class: "info-icon"
      }), _createElementVNode("span", _hoisted_19, "Channel: " + _toDisplayString($options.maskText(channel.chatId)), 1)])) : _createCommentVNode("", true)], 64)) : channelType.value === 'cfr2' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_font_awesome_icon, {
        icon: "link",
        class: "info-icon"
      }), _createElementVNode("span", {
        class: "info-text",
        title: channel.publicUrl
      }, _toDisplayString(channel.publicUrl || _ctx.$t('sysUpload.notSet')), 9, _hoisted_21)])) : channelType.value === 's3' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_font_awesome_icon, {
        icon: "server",
        class: "info-icon"
      }), _createElementVNode("span", _hoisted_23, _toDisplayString(channel.bucketName || _ctx.$t('sysUpload.notSet')), 1)]), channel.endpoint ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_font_awesome_icon, {
        icon: "link",
        class: "info-icon"
      }), _createElementVNode("span", {
        class: "info-text",
        title: channel.endpoint
      }, _toDisplayString(channel.endpoint), 9, _hoisted_25)])) : _createCommentVNode("", true)], 64)) : channelType.value === 'discord' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_font_awesome_icon, {
        icon: "robot",
        class: "info-icon"
      }), _createElementVNode("span", _hoisted_27, "Bot: " + _toDisplayString($options.maskText(channel.botToken)), 1)]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_font_awesome_icon, {
        icon: "hashtag",
        class: "info-icon"
      }), _createElementVNode("span", _hoisted_29, "Channel: " + _toDisplayString($options.maskText(channel.channelId)), 1)]), channel.isNitro ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        size: "small",
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [_createTextVNode("Nitro", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : channelType.value === 'huggingface' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_font_awesome_icon, {
        icon: "database",
        class: "info-icon"
      }), _createElementVNode("span", _hoisted_31, _toDisplayString(channel.repo || _ctx.$t('sysUpload.notSet')), 1)]), channel.isPrivate ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        size: "small",
        type: "warning"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.privateRepo')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : channelType.value === 'webdav' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 5
      }, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_font_awesome_icon, {
        icon: "folder",
        class: "info-icon"
      }), _createElementVNode("span", {
        class: "info-text",
        title: channel.baseUrl
      }, _toDisplayString(channel.baseUrl || _ctx.$t('sysUpload.notSet')), 9, _hoisted_33)]), channel.publicUrl ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_font_awesome_icon, {
        icon: "link",
        class: "info-icon"
      }), _createElementVNode("span", {
        class: "info-text",
        title: channel.publicUrl
      }, _toDisplayString(channel.publicUrl), 9, _hoisted_35)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), channel.quota?.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_el_progress, {
        percentage: $options.getQuotaPercentage(channel),
        status: $options.getQuotaStatus(channel),
        "stroke-width": 6
      }, null, 8, ["percentage", "status"]), _createElementVNode("span", _hoisted_37, _toDisplayString($options.getQuotaText(channel)), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_button, {
        text: "",
        type: "primary",
        size: "small",
        onClick: $event => $options.openDetailDialog(channelType.value, index)
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "eye",
          style: {
            "margin-right": "4px"
          }
        }), _createTextVNode(_toDisplayString(_ctx.$t('sysUpload.detail')), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        text: "",
        type: "primary",
        size: "small",
        onClick: $event => $options.openEditDialog(channelType.value, index)
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "edit",
          style: {
            "margin-right": "4px"
          }
        }), _createTextVNode(_toDisplayString(_ctx.$t('sysUpload.editBtn')), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        text: "",
        type: "danger",
        size: "small",
        onClick: $event => $options.deleteChannel(channelType.value, index),
        disabled: channel.fixed
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "trash-alt",
          style: {
            "margin-right": "4px"
          }
        }), _createTextVNode(_toDisplayString(_ctx.$t('sysUpload.deleteBtn')), 1)]),
        _: 1
      }, 8, ["onClick", "disabled"])])], 42, _hoisted_10);
    }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_font_awesome_icon, {
      icon: "inbox",
      class: "empty-icon"
    }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysUpload.noChannels', {
      type: channelType.label
    })), 1)]))]);
  }), 128)), _createVNode(_component_el_dialog, {
    modelValue: $data.showAddDialog,
    "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.showAddDialog = $event),
    title: _ctx.$t('sysUpload.addDialogTitle'),
    class: "channel-dialog",
    "destroy-on-close": "",
    onClosed: $options.resetAddForm
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[34] || (_cache[34] = $event => $data.showAddDialog = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.cancel')), 1)]),
      _: 1
    }), $data.newChannel.type !== 'cfr2' ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "primary",
      onClick: $options.confirmAddChannel
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.confirmAdd')), 1)]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.newChannel,
      "label-position": "top",
      ref: "addForm",
      rules: $options.addRules
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.channelTypeLabel'),
        prop: "type"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.newChannel.type,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.newChannel.type = $event),
          placeholder: _ctx.$t('sysUpload.channelTypePlaceholder'),
          style: {
            "width": "100%"
          },
          onChange: $options.onChannelTypeChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.addableChannels, ch => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: ch.value,
              label: ch.label,
              value: ch.value
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_40, [_createVNode(_component_ChannelIcon, {
                type: ch.value,
                class: "select-option-icon"
              }, null, 8, ["type"]), _createElementVNode("span", null, _toDisplayString(ch.label), 1)])]),
              _: 2
            }, 1032, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onChange"])]),
        _: 1
      }, 8, ["label"]), $data.newChannel.type === 'cfr2' ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_font_awesome_icon, {
        icon: "info-circle",
        style: {
          "margin-right": "6px"
        }
      }), _createElementVNode("span", {
        innerHTML: _ctx.$t('sysUpload.r2ConfigNote')
      }, null, 8, _hoisted_42)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_form_item, {
        prop: "name"
      }, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.channelNameLabel')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.channelNameImmutableTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "exclamation-triangle",
            class: "inline-warning-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.name,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.newChannel.name = $event),
          placeholder: _ctx.$t('sysUpload.channelNamePlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), $data.newChannel.type === 'telegram' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.botTokenLabel'),
        prop: "botToken"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.botToken,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.newChannel.botToken = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.botTokenPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.chatIdLabel'),
        prop: "chatId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.chatId,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.newChannel.chatId = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.chatIdPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.proxyDomain')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.proxyUrl,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.newChannel.proxyUrl = $event),
          placeholder: _ctx.$t('sysUpload.proxyDomainPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"])], 64)) : $data.newChannel.type === 's3' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.endpointLabel'),
        prop: "endpoint"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.endpoint,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.newChannel.endpoint = $event),
          placeholder: _ctx.$t('sysUpload.endpointPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.cdnDomain')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.cdnDomainTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.cdnDomain,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.newChannel.cdnDomain = $event),
          placeholder: _ctx.$t('sysUpload.cdnDomainPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.bucketName'),
        prop: "bucketName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.bucketName,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.newChannel.bucketName = $event),
          placeholder: _ctx.$t('sysUpload.bucketNamePlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.bucketRegion'),
        prop: "region"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.region,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.newChannel.region = $event),
          placeholder: _ctx.$t('sysUpload.bucketRegionPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.accessKeyId'),
        prop: "accessKeyId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.accessKeyId,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.newChannel.accessKeyId = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.accessKeyIdPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.secretAccessKey'),
        prop: "secretAccessKey"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.secretAccessKey,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.newChannel.secretAccessKey = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.secretAccessKeyPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.pathStyle')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.pathStyleTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newChannel.pathStyle,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.newChannel.pathStyle = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimit')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newChannel.quota.enabled,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.newChannel.quota.enabled = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), $data.newChannel.quota?.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimitGB')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.newChannel.quota.limitGB,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.newChannel.quota.limitGB = $event),
          min: 0.1,
          step: 1,
          precision: 1
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaThreshold')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.newChannel.quota.threshold,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.newChannel.quota.threshold = $event),
          min: 50,
          max: 100,
          step: 5
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])], 64)) : _createCommentVNode("", true)], 64)) : $data.newChannel.type === 'discord' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.botTokenLabel'),
        prop: "botToken"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.botToken,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.newChannel.botToken = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.botTokenPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.channelIdLabel'),
        prop: "channelId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.channelId,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.newChannel.channelId = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.channelIdPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.proxyDomain')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.proxyUrl,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.newChannel.proxyUrl = $event),
          placeholder: _ctx.$t('sysUpload.proxyDomainPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.nitroMember')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.nitroTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newChannel.isNitro,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.newChannel.isNitro = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_43, [_createVNode(_component_font_awesome_icon, {
        icon: "exclamation-triangle",
        style: {
          "margin-right": "6px"
        }
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('sysUpload.discordWarning')), 1)])], 64)) : $data.newChannel.type === 'huggingface' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.repoName'),
        prop: "repo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.repo,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.newChannel.repo = $event),
          placeholder: _ctx.$t('sysUpload.repoNamePlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.accessToken'),
        prop: "token"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.token,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.newChannel.token = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.accessTokenPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.privateRepo')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.privateRepoTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newChannel.isPrivate,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.newChannel.isPrivate = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })], 64)) : $data.newChannel.type === 'webdav' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavBaseUrl'),
        prop: "baseUrl"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.baseUrl,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.newChannel.baseUrl = $event),
          placeholder: _ctx.$t('sysUpload.webdavBaseUrlPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavUsername')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.username,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.newChannel.username = $event),
          placeholder: _ctx.$t('sysUpload.webdavUsernamePlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavPassword')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.password,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.newChannel.password = $event),
          type: "password",
          "show-password": "",
          placeholder: _ctx.$t('sysUpload.webdavPasswordPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.publicUrl')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.webdavPublicUrlTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.publicUrl,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.newChannel.publicUrl = $event),
          placeholder: _ctx.$t('sysUpload.webdavPublicUrlPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavHeaders')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newChannel.headersText,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.newChannel.headersText = $event),
          type: "textarea",
          autosize: {
            minRows: 2
          },
          placeholder: _ctx.$t('sysUpload.webdavHeadersPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.webdavCreateDirectory')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.webdavCreateDirectoryTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newChannel.createDirectory,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.newChannel.createDirectory = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimit')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newChannel.quota.enabled,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.newChannel.quota.enabled = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), $data.newChannel.quota?.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimitGB')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.newChannel.quota.limitGB,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $data.newChannel.quota.limitGB = $event),
          min: 0.1,
          step: 1,
          precision: 1
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaThreshold')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.newChannel.quota.threshold,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.newChannel.quota.threshold = $event),
          min: 50,
          max: 100,
          step: 5
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64))]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue", "title", "onClosed"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showDetailDialog,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $data.showDetailDialog = $event),
    title: _ctx.$t('sysUpload.detailDialogTitle', {
      name: $data.currentChannel?.name || ''
    }),
    class: "channel-dialog",
    onClosed: $options.resetDetailData
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[36] || (_cache[36] = $event => $data.showDetailDialog = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.closeBtn')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.openEditFromDetail
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.editBtn')), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_el_descriptions, {
      column: 1,
      border: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.channelNameDetail')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.name), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.channelTypeDetail')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getChannelTypeLabel($data.currentChannelType)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.statusLabel')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tag, {
          type: $data.currentChannel?.enabled ? 'success' : 'info'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.enabled ? _ctx.$t('sysUpload.enabled') : _ctx.$t('sysUpload.disabled')), 1)]),
          _: 1
        }, 8, ["type"])]),
        _: 1
      }, 8, ["label"]), $data.currentChannel?.fixed ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
        key: 0,
        label: _ctx.$t('sysUpload.configSource')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tag, {
          type: "warning"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.envVariable')), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), $data.currentChannelType === 'telegram' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.botTokenLabel')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.maskText($data.currentChannel?.botToken, 10)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.chatIdLabel')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.maskText($data.currentChannel?.chatId, 6)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.proxyDomain')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.proxyUrl || _ctx.$t('sysUpload.notSet')), 1)]),
        _: 1
      }, 8, ["label"])], 64)) : $data.currentChannelType === 'cfr2' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
        key: 2,
        label: _ctx.$t('sysUpload.publicUrl')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          "model-value": $data.currentChannel?.publicUrl || _ctx.$t('sysUpload.notSet'),
          readonly: ""
        }, null, 8, ["model-value"])]),
        _: 1
      }, 8, ["label"])) : $data.currentChannelType === 's3' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.endpointLabel')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          "model-value": $data.currentChannel?.endpoint,
          readonly: ""
        }, null, 8, ["model-value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.cdnDomain')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          "model-value": $data.currentChannel?.cdnDomain || _ctx.$t('sysUpload.notSet'),
          readonly: ""
        }, null, 8, ["model-value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.bucketName')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.bucketName), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.bucketRegion')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.region), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.pathStyle')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.pathStyle ? _ctx.$t('sysUpload.isPathStyle') : _ctx.$t('sysUpload.isNotPathStyle')), 1)]),
        _: 1
      }, 8, ["label"])], 64)) : $data.currentChannelType === 'discord' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.botTokenLabel')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.maskText($data.currentChannel?.botToken, 10)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.channelIdLabel')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.maskText($data.currentChannel?.channelId, 6)), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.proxyDomain')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.proxyUrl || _ctx.$t('sysUpload.notSet')), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.nitroMember')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.isNitro ? _ctx.$t('sysUpload.isPathStyle') : _ctx.$t('sysUpload.isNotPathStyle')), 1)]),
        _: 1
      }, 8, ["label"])], 64)) : $data.currentChannelType === 'huggingface' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 5
      }, [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.repoName')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.repo), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.privateRepo')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.isPrivate ? _ctx.$t('sysUpload.isPathStyle') : _ctx.$t('sysUpload.isNotPathStyle')), 1)]),
        _: 1
      }, 8, ["label"])], 64)) : $data.currentChannelType === 'webdav' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 6
      }, [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.webdavBaseUrl')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          "model-value": $data.currentChannel?.baseUrl,
          readonly: ""
        }, null, 8, ["model-value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.publicUrl')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          "model-value": $data.currentChannel?.publicUrl || _ctx.$t('sysUpload.notSet'),
          readonly: ""
        }, null, 8, ["model-value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.webdavUsername')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.username || _ctx.$t('sysUpload.notSet')), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.webdavHeaders')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          "model-value": $options.formatHeaders($data.currentChannel?.headers),
          type: "textarea",
          autosize: {
            minRows: 2
          },
          readonly: ""
        }, null, 8, ["model-value"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.webdavCreateDirectory')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.createDirectory !== false ? _ctx.$t('sysUpload.isPathStyle') : _ctx.$t('sysUpload.isNotPathStyle')), 1)]),
        _: 1
      }, 8, ["label"])], 64)) : _createCommentVNode("", true), $data.currentChannel?.quota?.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 7
      }, [_createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.quotaLimit')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.quota?.limitGB) + " GB", 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, {
        label: _ctx.$t('sysUpload.quotaThreshold')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.currentChannel?.quota?.threshold) + "%", 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_createElementVNode("span", _hoisted_44, [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.currentUsage')) + " ", 1), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $options.refreshQuota,
          class: "refresh-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "sync-alt",
            class: _normalizeClass({
              'fa-spin': $data.quotaLoading
            })
          }, null, 8, ["class"])]),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_progress, {
          percentage: $options.getQuotaPercentage($data.currentChannel),
          status: $options.getQuotaStatus($data.currentChannel),
          "stroke-width": 16,
          "text-inside": true,
          format: () => $options.getQuotaText($data.currentChannel)
        }, null, 8, ["percentage", "status", "format"]), _createElementVNode("div", {
          class: _normalizeClass(["quota-info", {
            'quota-warning': $options.isQuotaExceeded($data.currentChannel)
          }])
        }, _toDisplayString($options.getQuotaStatusText($data.currentChannel)), 3)])]),
        _: 1
      })], 64)) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "title", "onClosed"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showEditDialog,
    "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => $data.showEditDialog = $event),
    title: _ctx.$t('sysUpload.editDialogTitle', {
      name: $data.editChannel?.name || ''
    }),
    class: "channel-dialog",
    "destroy-on-close": "",
    onClosed: $options.resetEditData
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[76] || (_cache[76] = $event => $data.showEditDialog = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.cancel')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.confirmEditChannel
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.saveChanges')), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.editChannel,
      "label-position": "top",
      ref: "editForm",
      rules: $options.editRules
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        prop: "name"
      }, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.channelNameLabel')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.channelNameEditDisabledTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "exclamation-triangle",
            class: "inline-warning-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.name,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.editChannel.name = $event),
          disabled: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.enableChannel')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.enabled,
          "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => $data.editChannel.enabled = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), $data.currentChannelType === 'telegram' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.botTokenLabel'),
        prop: "botToken"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.botToken,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.editChannel.botToken = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.chatIdLabel'),
        prop: "chatId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.chatId,
          "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.editChannel.chatId = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.proxyDomain')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.proxyUrl,
          "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => $data.editChannel.proxyUrl = $event),
          placeholder: _ctx.$t('sysUpload.proxyDomainPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"])], 64)) : $data.currentChannelType === 'cfr2' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.publicUrl')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.publicUrl,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $data.editChannel.publicUrl = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimit')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.quota.enabled,
          "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $data.editChannel.quota.enabled = $event),
          onChange: _cache[45] || (_cache[45] = val => $options.onQuotaEnabledChange(val, $data.editChannel))
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), $data.editChannel.quota?.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimitGB')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.editChannel.quota.limitGB,
          "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $data.editChannel.quota.limitGB = $event),
          min: 0.1,
          step: 1,
          precision: 1
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaThreshold')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.editChannel.quota.threshold,
          "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.editChannel.quota.threshold = $event),
          min: 50,
          max: 100,
          step: 5
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])], 64)) : _createCommentVNode("", true)], 64)) : $data.currentChannelType === 's3' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.endpointLabel'),
        prop: "endpoint"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.endpoint,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.editChannel.endpoint = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.cdnDomain')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.cdnDomainTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.cdnDomain,
          "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => $data.editChannel.cdnDomain = $event),
          placeholder: _ctx.$t('sysUpload.cdnDomainPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.bucketName'),
        prop: "bucketName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.bucketName,
          "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $data.editChannel.bucketName = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.bucketRegion'),
        prop: "region"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.region,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.editChannel.region = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.accessKeyId'),
        prop: "accessKeyId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.accessKeyId,
          "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.editChannel.accessKeyId = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.secretAccessKey'),
        prop: "secretAccessKey"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.secretAccessKey,
          "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => $data.editChannel.secretAccessKey = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.pathStyle')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.pathStyleTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.pathStyle,
          "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => $data.editChannel.pathStyle = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimit')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.quota.enabled,
          "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => $data.editChannel.quota.enabled = $event),
          onChange: _cache[56] || (_cache[56] = val => $options.onQuotaEnabledChange(val, $data.editChannel))
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), $data.editChannel.quota?.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimitGB')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.editChannel.quota.limitGB,
          "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => $data.editChannel.quota.limitGB = $event),
          min: 0.1,
          step: 1,
          precision: 1
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaThreshold')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.editChannel.quota.threshold,
          "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => $data.editChannel.quota.threshold = $event),
          min: 50,
          max: 100,
          step: 5
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])], 64)) : _createCommentVNode("", true)], 64)) : $data.currentChannelType === 'discord' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.botTokenLabel'),
        prop: "botToken"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.botToken,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => $data.editChannel.botToken = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.channelIdLabel'),
        prop: "channelId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.channelId,
          "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => $data.editChannel.channelId = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.proxyDomain')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.proxyUrl,
          "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => $data.editChannel.proxyUrl = $event),
          placeholder: _ctx.$t('sysUpload.proxyDomainPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.nitroMember')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.nitroTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.isNitro,
          "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => $data.editChannel.isNitro = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })], 64)) : $data.currentChannelType === 'huggingface' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.repoName'),
        prop: "repo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.repo,
          "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => $data.editChannel.repo = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.accessToken'),
        prop: "token"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.token,
          "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => $data.editChannel.token = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.privateRepo')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.privateRepoTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.isPrivate,
          "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => $data.editChannel.isPrivate = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })], 64)) : $data.currentChannelType === 'webdav' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 5
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavBaseUrl'),
        prop: "baseUrl"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.baseUrl,
          "onUpdate:modelValue": _cache[66] || (_cache[66] = $event => $data.editChannel.baseUrl = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavUsername')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.username,
          "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => $data.editChannel.username = $event),
          disabled: $data.editChannel.fixed
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavPassword')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.password,
          "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => $data.editChannel.password = $event),
          disabled: $data.editChannel.fixed,
          type: "password",
          "show-password": ""
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.publicUrl')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.webdavPublicUrlTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.publicUrl,
          "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => $data.editChannel.publicUrl = $event),
          placeholder: _ctx.$t('sysUpload.webdavPublicUrlPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.webdavHeaders')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editChannel.headersText,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => $data.editChannel.headersText = $event),
          type: "textarea",
          autosize: {
            minRows: 2
          },
          placeholder: _ctx.$t('sysUpload.webdavHeadersPlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysUpload.webdavCreateDirectory')) + " ", 1), _createVNode(_component_el_tooltip, {
          content: _ctx.$t('sysUpload.webdavCreateDirectoryTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "question-circle",
            class: "inline-help-icon"
          })]),
          _: 1
        }, 8, ["content"])]),
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.createDirectory,
          "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => $data.editChannel.createDirectory = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimit')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editChannel.quota.enabled,
          "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => $data.editChannel.quota.enabled = $event),
          onChange: _cache[73] || (_cache[73] = val => $options.onQuotaEnabledChange(val, $data.editChannel))
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), $data.editChannel.quota?.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaLimitGB')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.editChannel.quota.limitGB,
          "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => $data.editChannel.quota.limitGB = $event),
          min: 0.1,
          step: 1,
          precision: 1
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysUpload.quotaThreshold')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.editChannel.quota.threshold,
          "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => $data.editChannel.quota.threshold = $event),
          min: 50,
          max: 100,
          step: 5
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue", "title", "onClosed"])])), [[_directive_loading, $data.loading]]);
}